import React, { ReactNode, useEffect } from 'react';
import AutoSuggest from '../common/AutoSuggest';
import useRouter from '../hook/useRouter';
import { Config } from '../interface/ICommon';

export interface ISearchFormProp {
    placeholderStr: string;
    submitCallback: (_q: string) => void;
    l10n: { [key: string]: string };
    watch: string;
    resetObj: { [key: string]: string };
    config: Config;
    apiPath: string;
}
const autoSuggest = new AutoSuggest();

export const SearchForm = ({ props, children }: { props: ISearchFormProp; children: ReactNode }) => {
    const { params, getValue, changeParam } = useRouter([props.watch]);

    useEffect(() => {
        if (!params) return;
        const value = getValue(props.watch);
        if (!value) return;

        autoSuggest.value(value);
    }, [params]);

    useEffect(() => {
        autoSuggest.init({
            apiUrl: `${props.config.apiDomain}/${props.config.service}${props.apiPath}`,
            // apiUrl: `${props.config.apiDomain}/${props.config.service}/v2.0/price/search/item/suggest`,
            selector: '#autoSuggest',
            cookieName: `${props.config.service}GameInfoAutoSuggest-itemprice`,
            keywordParamName: 'searchKeyword',
            size: 10,
            useDelbtn: true,
            locale: props.config.locale,
            submitCallback: (_q, _isListClick) => {
                props.submitCallback(_q);
                changeParam({ [props.watch]: _q, exactsearch: _isListClick.toString(), ...props.resetObj });
            },
        });
    }, []);

    return (
        <div className="gameinfo-search-wrapper ncui-searchform">
            {children}
            <form
                data-name="suggest_form"
                id="autoSuggest"
                className="gameinfo-search"
                method="get"
                action=""
                onSubmit={(e) => e.preventDefault()}
                role="search"
            >
                <input type="search" autoComplete="off" data-name="suggest_input" placeholder={props.placeholderStr} />
                <button value="X" title="Delete" data-name="suggest_delete"></button>
                <button value="GO" title="Search" data-name="suggest_submit"></button>
                <div data-name="suggest_wrap">
                    <div data-name="suggest_list">
                        <div data-name="suggest_scroll">
                            <ul></ul>
                        </div>
                    </div>
                    <div data-name="suggest_recent">
                        <div data-name="suggest_recent_scroll">
                            <ul></ul>
                            <div data-name="suggest_recent-none" style={{ display: 'none' }}>
                                {props.l10n['common.norecentsearchhistory']}
                            </div>
                        </div>
                        <div data-name="suggest_recent-del">
                            <button type="button">{props.l10n['common.deleteallrecent']}</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};
